// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import arrowNarrowRightIcon from "@/assets/icons/arrow-narrow-right.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type ArrowNarrowRightIconProps = Omit<IconProps, "name">;

export function ArrowNarrowRightIcon(props: ArrowNarrowRightIconProps): React.ReactNode {
  return <Icon name={arrowNarrowRightIcon} {...props} />;
}
